module.exports = __webpack_public_path__ + "img/g-j_bg.71ea4816.png";